import { setupWorker } from "msw/browser";
import { mockTokenExpired } from "./handlers/_demo";
import { menuList } from "./handlers/_menu";
// import { usersList } from "./handlers/_user"; // Commented out to disable user mocking

const handlers = [mockTokenExpired, menuList]; // Removed usersList
const worker = setupWorker(...handlers);

export { worker };
